/****************************************************
 * Module Name:  userColumnRoleProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class UserColumnRoleProxy {
    static GrantUserColumnRole = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/columnrole/user/grant",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RevokeUserColumnRole = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/columnrole/user/revoke",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GrantVirtualTeamColumnRole = (vtid, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/columnrole/virtualteam/grant/${vtid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RevokeVirtualTeamColumnRole = (vtid, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/columnrole/virtualteam/revoke/${vtid}`,
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
